export const iconFontAwesomeBuildingsHouseCircleXmark = (
	<i className="fa-solid fa-house-circle-xmark"></i>
);
